import { useEffect } from "react";

const TwitterEmbed = ({ url, caption }) => {
    useEffect(() => {
        // Load Twitter widgets script if not already loaded
        if (!window.twttr) {
            const script = document.createElement("script");
            script.src = "https://platform.twitter.com/widgets.js";
            script.async = true;
            document.body.appendChild(script);
            script.onload = () => window.twttr?.widgets.load();
        } else {
            window.twttr.widgets.load(); // re-process new blockquote
        }
    }, [url]);

    return (
        <blockquote className="twitter-tweet">
            <a href={url}></a>
        </blockquote>
    );
};

export default TwitterEmbed;
